const getFeatureFlagDeveloper = state => state.featureFlagDeveloper

export { getFeatureFlagDeveloper }
